import moment from "moment";
import { themeColor } from "@/main.ts";

export default class SkeletonGraph {
  yDaily = [
    23,
    25,
    30,
    35,
    45,
    15,
    17,
    48,
    45,
    44,
    43,
    32,
    37,
    23,
    27,
    16,
    16,
    20,
    23,
    26,
    27,
    29,
    31,
    34
  ];
  setInitialData(interval, accum) {
    let y = [];
    if (!interval) return [];
    let limitDate;
    let start = 0;
    let endPeriod;
    switch (interval) {
      case "hourly":
        y = [...this.yDaily];
        limitDate = parseInt(moment().format("HH")) + 1;
        endPeriod =
          parseInt(
            moment()
              .endOf("day")
              .format("HH")
          ) + 1;
        break;
      case "daily":
        y = [...this.yDaily];
        start = 1;
        limitDate = parseInt(moment().format("DD")) + 1;
        endPeriod =
          parseInt(
            moment()
              .endOf("month")
              .format("DD")
          ) + 1;
        break;
      case "monthly":
        y = [...this.yDaily];
        start = 1;
        limitDate = parseInt(moment().format("MM")) + 1;
        endPeriod =
          parseInt(
            moment()
              .endOf("year")
              .format("MM")
          ) + 1;

        break;
    }

    if (accum) {
    y =  this.sumAccum(y);
    }
    let data = [];
    for (let i = start; i < endPeriod; i++) {
      let val = i < limitDate ? y[i] : null;
      data.push({ x: this.setDate(i, interval), y: val });
    }
    return data;
  }
  sumAccum(y) {
    let beforeValue = 0;
    for (let i = 0; i < y.length; i++) {
      y[i] += beforeValue;
      beforeValue = y[i]
    }

   
    return y
  }
  setDate(val, interval) {
    if (!interval) return;
    let format = undefined;
    switch (interval) {
      case "hourly":
        format = val < 10 ? `YYYY-MM-DDT0${val}:00:00` : `YYYY-MM-DDT${val}:00:00`;
        break;
      case "daily":
        format = val < 10 ? `YYYY-MM-0${val}T00:00:00` : `YYYY-MM-${val}T00:00:00`;
        break;
      case "monthly":
        format = val < 10 ? `YYYY-0${val}-01T00:00:00` : `YYYY-${val}-01T00:00:00`;
        break;
    }
    return moment().format(format);
  }
  setInitialDataset(interval, label, dataset) {
    if (dataset) {
      dataset["data"] = this.setInitialData(interval);
      return dataset;
    }

    switch (interval) {
      case "hourly":
        return {
          data: this.setInitialData(interval),
          type: "line",
          borderWidth: 2,
          borderColor: themeColor("loading"),
          yAxisID: "left",
          fill: false,
          label: label
        };
      case "daily":
        return {
          data: this.setInitialData(interval),
          type: "line",
          borderWidth: 2,
          borderColor: themeColor("loading"),
          yAxisID: "left",
          fill: false,
          label: label
        };
      case "monthly":
        return {
          data: this.setInitialData(interval),
          type: "bar",
          backgroundColor: "#72C4D6",
          borderColor: "#72C4D6",
          label: label
        };
      default:
        return {
          data: this.setInitialData(interval),
          type: "line",
          borderWidth: 2,
          borderColor: themeColor("loading"),
          yAxisID: "left",
          fill: false,
          label: label
        };
    }
  }
}
